<template>
  <div
    class="rules-panel"
    :class="{ 'dashboard-node--highlight': highlighted }"
  >
    <BaseDashboardTable
      :columns="columns"
      :rows="rows"
      :item-key="itemKey"
      :hide-default-footer="false"
      :server-items-length="serverItemsLength"
      :options="options"
      @action="$emit('action', $event)"
      @update:options="$emit('update:options', { instance, options: $event })"
    >
      <template v-slot:cell="{ column, row }">
        <BaseDashboardTableCell
          :column="column"
          :row="row"
          :data-field="cellDataField(column, row)"
          :data-row-key="rowKeyOf(row)"
          @detail="$emit('row-detail', $event)"
          @action="$emit('action', $event)"
        >
          <span
            v-if="column.key in (row.results || {})"
            class="rules-panel__icon"
            :class="row.results[column.key] ? 'rules-panel__icon--ok' : 'rules-panel__icon--no'"
          >
            {{ row.results[column.key] ? '✓' : '✕' }}
          </span>
          <span v-else>{{ row[column.key] }}</span>
        </BaseDashboardTableCell>
      </template>
    </BaseDashboardTable>
  </div>
</template>

<script>
import BaseDashboardTable from './BaseDashboardTable.vue'
import BaseDashboardTableCell from './BaseDashboardTableCell.vue'
import { sanitizeDataField } from './dataFieldUtils'
import DashboardHighlightOnRender from '../../mixins/DashboardHighlightOnRender'

export default {
  name: 'BaseRulesPanel',
  mixins: [DashboardHighlightOnRender],
  components: { BaseDashboardTable, BaseDashboardTableCell },
  props: {
    columns: {
      type: Array,
      required: true
    },
    rows: {
      type: Array,
      required: true
    },
    itemKey: {
      type: String,
      required: false,
      default: undefined
    },
    instance: {
      type: String,
      required: false,
      default: ''
    },
    serverItemsLength: {
      type: Number,
      required: false,
      default: -1
    },
    options: {
      type: Object,
      required: false,
      default: () => ({})
    }
  },
  methods: {
    rowKeyOf(row) {
      if (!row) {
        return undefined
      }
      if (row._rowKey) {
        return sanitizeDataField(row._rowKey)
      }
      if (!this.itemKey) {
        return undefined
      }
      const value = this.itemKey.split('.').reduce((acc, key) => (acc == null ? acc : acc[key]), row)
      return sanitizeDataField(value)
    },
    cellDataField(column, row) {
      const rowKey = this.rowKeyOf(row)
      return rowKey ? `${sanitizeDataField(column.key)}-${rowKey}` : sanitizeDataField(column.key)
    }
  }
}
</script>

<style lang="scss">
.rules-panel {
  &__icon {
    font-size: 1rem;
    font-weight: 700;

    &--ok {
      color: var(--v-success-base);
    }

    &--no {
      color: var(--v-error-base);
    }
  }
}
</style>
